import EventEmitter from 'events';

import util from '../tools/util';
import UserStore from './user_store';

export default {
  once,
  addChangeListener,
  removeChangeListener,
  init,
  isReady,
  getList,
  getUser,
  fetch,
  fetchUser,
  addUser,
  updateUser,
  deleteUser,
  addVolume,
  deleteVolume,
  addOrg,
  deleteOrg,
  addDevice,
};

let g_userList: any = null;
const g_userMap: Map<number, any> = new Map();

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function once(callback) {
  g_eventEmitter.once(CHANGE_EVENT, callback);
}
function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function init(done) {
  done && done();
}
function isReady() {
  return true;
}
function getList() {
  return g_userList;
}
function getUser(user_id: number) {
  return g_userMap.get(user_id);
}

function fetch(done?: (err: any) => void) {
  const opts = {
    url: `/api/1/admin/user`,
  };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('UserAdminStore.fetch: err:', err);
    } else if (body) {
      if (!util.deepEqual(g_userList, body.user_list)) {
        g_userList = body.user_list;
        _emit('update');
      }
    }
    if (done) {
      done(err);
    }
  });
}
function fetchUser(user_id, done?: (err: string, user: any) => void) {
  const opts = {
    url: `/api/1/admin/user/${user_id}`,
  };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('UserAdminStore.getUser: err:', err);
    } else {
      g_userMap.set(user_id, body);
      _emit('user');
    }
    if (done) {
      done(err, body);
    }
  });
}

function addUser(params, done) {
  const { user_name, password, email } = params;
  const opts = {
    url: `/api/1/admin/user`,
    body: {
      user_name,
      password,
      email,
    },
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('UserAdminStore.addUser: err:', err, body);
      done(err);
    } else {
      fetch(() => done(null, body));
    }
  });
}
function updateUser(params, done) {
  const { user_id, user_name, password, email } = params;
  const opts = {
    url: `/api/1/admin/user/${user_id}`,
    body: {
      user_name,
      password,
      email,
    },
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('UserAdminStore.updateUser: err:', err, body);
      done(err);
    } else {
      fetch(done);
    }
  });
}
function deleteUser(user_id, done) {
  const opts = {
    url: `/api/1/admin/user/${user_id}`,
  };
  UserStore.del(opts, (err, body) => {
    if (err) {
      util.errorLog('UserAdminStore.deletuser: err:', err, body);
      done(err);
    } else {
      fetch(done);
    }
  });
}
function addVolume(params, done) {
  const { user_id, volume_id } = params;
  const opts = {
    url: `/api/1/admin/user/${user_id}/volume/${volume_id}`,
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('UserAdminStore.addVolume: err:', err, body);
      done(err);
    } else {
      fetchUser(user_id, done);
    }
  });
}
function deleteVolume(params, done) {
  const { user_id, volume_id } = params;
  const opts = {
    url: `/api/1/admin/user/${user_id}/volume/${volume_id}`,
  };
  UserStore.del(opts, (err, body) => {
    if (err) {
      util.errorLog('UserAdminStore.deleteVolume: err:', err, body);
      done(err);
    } else {
      fetchUser(user_id, done);
    }
  });
}
function addOrg(params, done) {
  const { user_id, org_id } = params;
  const opts = {
    url: `/api/1/admin/user/${user_id}/org/${org_id}`,
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('UserAdminStore.addOrg: err:', err, body);
      done(err);
    } else {
      fetchUser(user_id, done);
      fetch();
    }
  });
}
function deleteOrg(params, done) {
  const { user_id, org_id } = params;
  const opts = {
    url: `/api/1/admin/user/${user_id}/org/${org_id}`,
  };
  UserStore.del(opts, (err, body) => {
    if (err) {
      util.errorLog('UserAdminStore.deleteOrg: err:', err, body);
      done(err);
    } else {
      fetchUser(user_id, done);
      fetch();
    }
  });
}
function addDevice(params, done) {
  const { user_id, org_id, device_name } = params;
  const opts = {
    url: `/api/1/admin/device`,
    body: {
      user_id,
      org_id,
      device_name,
    },
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('UserAdminStore.addDevice: err:', err, body);
      done(err);
    } else {
      fetchUser(user_id, done);
    }
  });
}
